query PurchaseOrderSearchHints(
  $searchRequest: SearchRequestInput!
  $filterSupplierId: UUID
  $filterMultiStatusTypes: [Int]
  $isLinkSearch: Boolean
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $isSearchAllData: Boolean
) {
  purchaseOrderSearchHints(
    searchRequest: $searchRequest
    filterSupplierId: $filterSupplierId
    filterMultiStatusTypes: $filterMultiStatusTypes
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    isSearchAllData: $isSearchAllData
  ) {
    nodes {
      id
      caption
      linkType
      resultsCount
    }
  }
}
